export default (superClass) => {
    return class extends superClass {
        get company() {
            return {
                name: this._data.company_name,
                registrationNumber: this._data.company_registration_number,
                addres: this._data.company_addres,
                postalNumber: this._data.company_postal_number,
                county: this._data.company_county,
                phone: this._data.company_phone,
                email: this._data.company_email,
                website: this._data.company_website,
                links: {
                    allabolag: this._data.company_link_allabolag,
                    finansinspektionen: this._data.company_link_finansinspektionen,
                    hitta: this._data.company_link_hitta,
                    linkedin: this._data.company_link_linkedIn
                }
            }
        }
    }
}